import { Injectable } from '@angular/core';
import { HttpService } from '../../../core/services/http/http.service';
import { Store } from '@ngrx/store';
import { AppState} from 'src/store/reducers';
import { ChangeAnnStatus,ViewAnnouncement } from 'src/store/actions/announcementActions';
@Injectable({
  providedIn: 'root'
})
export class ViewannouncementsService {

  constructor(private http: HttpService,private store: Store<AppState>) { }

  getLocker() {
    return this.http.query('get', 'lock', {});
  }

  delLocker(id) {
    return this.http.query('delete','lock/'+id , {} );
  }
}
